export default __webpack_public_path__ + "static/media/pantry2-before2-2048w.c82f2290.webp";